import { BaseModel } from '@Core';
import { VehicleExempt } from './VehicleExempt';
import { Zones } from './Zones';
import { Camera } from './Camera';
import { Location } from './Locations';
import { GeoZones } from './GeoZones';
import { ContraventionReasons } from './ContraventionReasons';
import { ContraventionReasonTranslations } from './ContraventionReasonTranslations';

export interface PermitExempt extends BaseModel {
    ScopeId?: number;
    ScopeType: ScopeType;
    Notes?: string;
    VehicleExempts?: VehicleExempt[];
    Location?: Location;
    Zone?: Zones;
    Camera?: Camera;
    GeoZone?: GeoZones;
    ContraventionReasonId?: number;
    ContraventionReason?: ContraventionReasons;
    ContraventionReasonTranslation?: ContraventionReasonTranslations;
}

export enum ScopeType {
    Location,
    Zone,
    Camera,
    Global,
    GeoZone
}
